'use strict';

import { queryFirst, addClass, removeClass } from '../domUtil';
import { getJSON } from '../util';

const $body = $('body');
const hiddenClass = 'd-none';

export default {
    validateEmail: function () {
        $body.on('blur', '.notify-email', e => {
            const { target } = e;
            const { value } = target;
            const emailFormGroup = target.closest('.form-group');
            const emailError = queryFirst('.email-error', emailFormGroup);
            const { missingError, patternMismatch } = target.dataset;
            const invalidClass = 'is-invalid';
            if (!value) {
                addClass(target, invalidClass);
                emailError.textContent = missingError;
            } else if (target.checkValidity && !target.checkValidity()) {
                addClass(target, invalidClass);
                emailError.textContent = patternMismatch;
            } else {
                removeClass(target, invalidClass);
            }
        });
    },
    notifyMeSubmit: function () {
        $body.on('submit', '.notify-form', e => {
            e.preventDefault();
            const { target } = e;
            const actionUrl = target.getAttribute('action');
            const checkBoxValue = queryFirst('.notify-checkbox', target);
            const isChecked = checkBoxValue && checkBoxValue.value === 'true';
            const data = {
                productID: queryFirst('.notify-pid', target).value,
                email: queryFirst('.notify-email', target).value,
                subscribe: isChecked
            };
            $('.notify-form').spinner().start();
            getJSON(actionUrl, 'POST', data, (data) => {
                const confirmMessage = data.message;
                const notifyMeCntr = target.closest('.notify-me-container');
                const notifyMeDesc = queryFirst('.notify-me-desc', notifyMeCntr);
                addClass(notifyMeDesc, hiddenClass);
                addClass(target, hiddenClass);
                const notifyConfirm = queryFirst('.notify-me-confirm', notifyMeCntr);
                notifyConfirm.textContent = confirmMessage;
                removeClass(notifyConfirm, hiddenClass);
                removeClass(queryFirst('.footer-close-link', notifyMeCntr), hiddenClass);
                $.spinner().stop();
            }, () => {
                $.spinner().stop();
            });
        });
    },
    notifyMeCloseCTA: function () {
        // Code to close the nearest boostrap modal
        $body.on('click', '.lp-slideout-modal .close-current-modal', e => {
            e.preventDefault();
            const currentModal = $(e.target).closest('.lp-slideout-modal');

            if (currentModal.length) {
                currentModal.modal('hide');
            }
        });
    }
}